import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { showErrorNotification, showSuccessNotification, showErrorModal } from 'actions';
import * as actions from 'actions/ImportExportData';
import * as importApi from 'api/ImportExportData';

import {
  IMPORT_USER_DATA,
  IMPORT_ROUTES,
  UPLOAD_USERS_FILE,
  UPLOAD_ROUTES_FILE,
  EXTRACT_USER_DATA,
  EXTRACT_ROUTES,
  EXPORT_USER_DATA,
  EXPORT_ROUTES,
  IMPORT_ECA_EVENTS,
  UPLOAD_ECA_EVENTS_FILE,
  EXTRACT_ECA_EVENTS,
  EXPORT_ECA_EVENTS,
  GET_ROUTES_EXPORT_FORMATS,
} from 'constants/ActionTypes';

const getSchoolId = state => state.profile.school.id;

function* uploadUsersFile({ payload }) {
  try {
    const schoolId = yield select(getSchoolId);
    yield call(importApi.uploadUsersFile, { binary: payload, schoolId });
    yield put(actions.uploadUsersFileSuccess());
    yield put(showSuccessNotification('import.status.inProgress'));
  } catch (error) {
    yield put(showErrorModal(error.messages.toString()));
  }
}

function* uploadRoutesFile({ payload }) {
  try {
    const schoolId = yield select(getSchoolId);
    yield call(importApi.uploadRoutesFile, { binary: payload, schoolId });
    yield put(actions.uploadRoutesFileSuccess());
    yield put(showSuccessNotification('import.status.inProgress'));
  } catch (error) {
    yield put(showErrorModal(error.messages.toString()));
  }
}
function* importUserData() {
  try {
    const schoolId = yield select(getSchoolId);
    yield call(importApi.importUserData, schoolId);
    yield put(actions.importUserDataSuccess());
    yield put(showSuccessNotification('import.status.inProgress'));
  } catch (error) {
    yield put(actions.importUserDataError());
    yield put(showErrorNotification(error.messages));
  }
}

function* importRoutes() {
  try {
    const schoolId = yield select(getSchoolId);
    yield call(importApi.importRoutes, schoolId);
    yield put(actions.importRoutesSuccess());
    yield put(showSuccessNotification('import.status.inProgress'));
  } catch (error) {
    yield put(actions.importRoutesError());
    yield put(showErrorNotification(error.messages));
  }
}

function* extractUserData() {
  try {
    const schoolId = yield select(getSchoolId);
    yield call(importApi.extractUserData, schoolId);
    yield put(actions.extractUserDataSuccess());
    yield put(showSuccessNotification('extract.status.inProgress'));
  } catch (error) {
    yield put(actions.extractUserDataError());
    yield put(showErrorNotification(error.messages));
  }
}

function* extractRoutes({ payload: format }) {
  try {
    const schoolId = yield select(getSchoolId);
    yield call(importApi.extractRoutes, schoolId, format);
    yield put(actions.extractRoutesSuccess());
    yield put(showSuccessNotification('extract.status.inProgress'));
  } catch (error) {
    yield put(actions.extractRoutesError());
    yield put(showErrorNotification(error.messages));
  }
}

function* exportUserData() {
  try {
    const schoolId = yield select(getSchoolId);
    yield call(importApi.exportUserData, schoolId);
    yield put(actions.exportUserDataSuccess());
    yield put(showSuccessNotification('export.status.inProgress'));
  } catch (error) {
    yield put(actions.exportUserDataError());
    yield put(showErrorNotification(error.messages));
  }
}

function* exportRoutes({ payload: format }) {
  try {
    const schoolId = yield select(getSchoolId);
    yield call(importApi.exportRoutes, schoolId, format);
    yield put(actions.exportRoutesSuccess());
    yield put(showSuccessNotification('export.status.inProgress'));
  } catch (error) {
    yield put(actions.exportRoutesError());
    yield put(showErrorNotification(error.messages));
  }
}

function* getRoutesExportFormats() {
  try {
    const response = yield call(importApi.getRoutesExportFormats);
    yield put(actions.getRoutesExportFormatsSuccess(response.data));
  } catch (error) {
    yield put(actions.getRoutesExportFormatsError());
    yield put(showErrorNotification(error.messages));
  }
}

function* uploadEcaEventsFile({ payload }) {
  try {
    const schoolId = yield select(getSchoolId);
    yield call(importApi.uploadEcaEventsFile, { binary: payload, schoolId });
    yield put(actions.uploadEcaEventsFileSuccess());
    yield put(showSuccessNotification('import.status.inProgress'));
  } catch (error) {
    yield put(showErrorModal(error.messages.toString()));
  }
}

function* importEcaEvents() {
  try {
    const schoolId = yield select(getSchoolId);
    yield call(importApi.importEcaEvents, schoolId);
    yield put(actions.importEcaEventsSuccess());
    yield put(showSuccessNotification('import.status.inProgress'));
  } catch (error) {
    yield put(actions.importEcaEventsError());
    yield put(showErrorNotification(error.messages));
  }
}

function* extractEcaEvents() {
  try {
    const schoolId = yield select(getSchoolId);
    yield call(importApi.extractEcaEvents, schoolId);
    yield put(actions.extractEcaEventsSuccess());
    yield put(showSuccessNotification('extract.status.inProgress'));
  } catch (error) {
    yield put(actions.extractEcaEventsError());
    yield put(showErrorNotification(error.messages));
  }
}

function* exportEcaEvents() {
  try {
    const schoolId = yield select(getSchoolId);
    yield call(importApi.exportEcaEvents, schoolId);
    yield put(actions.exportEcaEventsSuccess());
    yield put(showSuccessNotification('export.status.inProgress'));
  } catch (error) {
    yield put(actions.exportEcaEventsError());
    yield put(showErrorNotification(error.messages));
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(IMPORT_USER_DATA, importUserData),
    takeLatest(IMPORT_ROUTES, importRoutes),
    takeLatest(UPLOAD_USERS_FILE, uploadUsersFile),
    takeLatest(UPLOAD_ROUTES_FILE, uploadRoutesFile),
    takeLatest(EXTRACT_USER_DATA, extractUserData),
    takeLatest(EXTRACT_ROUTES, extractRoutes),
    takeLatest(EXPORT_USER_DATA, exportUserData),
    takeLatest(EXPORT_ROUTES, exportRoutes),
    takeLatest(IMPORT_ECA_EVENTS, importEcaEvents),
    takeLatest(UPLOAD_ECA_EVENTS_FILE, uploadEcaEventsFile),
    takeLatest(EXTRACT_ECA_EVENTS, extractEcaEvents),
    takeLatest(EXPORT_ECA_EVENTS, exportEcaEvents),
    takeLatest(GET_ROUTES_EXPORT_FORMATS, getRoutesExportFormats),
  ]);
}
